
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class PetsGrid extends Serenity.EntityGrid<PetsRow, any> {
        protected getColumnsKey() { return PetsColumns.columnsKey; }
        protected getDialogType() { return PetsDialog; }
        protected getIdProperty() { return PetsRow.idProperty; }
        protected getInsertPermission() { return PetsRow.insertPermission; }
        protected getLocalTextPrefix() { return PetsRow.localTextPrefix; }
        protected getService() { return PetsService.baseUrl; }
        protected getIsActiveProperty() { return RestrictionsRow.isActiveProperty; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}